/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_HaircareInputs */

const en_val_haircare = /** @type {(inputs: Val_HaircareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haircare`)
};

const es_val_haircare = /** @type {(inputs: Val_HaircareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuidado del cabello`)
};

const fr_val_haircare = /** @type {(inputs: Val_HaircareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soin des cheveux`)
};

const de_val_haircare = /** @type {(inputs: Val_HaircareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haarpflege`)
};

const ja_val_haircare = /** @type {(inputs: Val_HaircareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ヘアケア`)
};

const zh_val_haircare = /** @type {(inputs: Val_HaircareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`护发`)
};

const ar_val_haircare = /** @type {(inputs: Val_HaircareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العناية بالشعر`)
};

const id_val_haircare = /** @type {(inputs: Val_HaircareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perawatan Rambut`)
};

const it_val_haircare = /** @type {(inputs: Val_HaircareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cura dei Capelli`)
};

const ru_val_haircare = /** @type {(inputs: Val_HaircareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Уход за волосами`)
};

const pt_val_haircare = /** @type {(inputs: Val_HaircareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuidados com o Cabelo`)
};

const ko_val_haircare = /** @type {(inputs: Val_HaircareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`헤어케어`)
};

/**
* | output |
* | --- |
* | "Haircare" |
*
* @param {Val_HaircareInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_haircare = /** @type {((inputs?: Val_HaircareInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_HaircareInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_haircare(inputs)
	if (locale === "es") return es_val_haircare(inputs)
	if (locale === "fr") return fr_val_haircare(inputs)
	if (locale === "de") return de_val_haircare(inputs)
	if (locale === "ja") return ja_val_haircare(inputs)
	if (locale === "zh") return zh_val_haircare(inputs)
	if (locale === "ar") return ar_val_haircare(inputs)
	if (locale === "id") return id_val_haircare(inputs)
	if (locale === "it") return it_val_haircare(inputs)
	if (locale === "ru") return ru_val_haircare(inputs)
	if (locale === "pt") return pt_val_haircare(inputs)
	return ko_val_haircare(inputs)
});